/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  Tag, Col, Row,
} from 'antd';
import { routeGenerator } from '../../../../../../utils/routes';
import getApplicationStatusTag from '../../utils/getApplicationStatusTag';


const getDisplayIdPostfix = (displayID) => {
  if (displayID?.includes('НИР') || displayID?.includes('С')) {
    return displayID;
  }
  return `${displayID}/25`;
};

const getCoexecutorColumns = () => [
  {
    title: '№',
    dataIndex: 'display_id',
    key: 'display_id',
    render: (_, object) => (
      <Col>
        <Row justify="center">
          <a onClick={() => window.open(routeGenerator.application2CoexecutorLink(object.id), '_blank')}>
            {getDisplayIdPostfix(object.display_id)}
          </a>
        </Row>
        <Row justify="center">
          <Tag color="gold">Соисполнитель</Tag>
        </Row>
      </Col>
    ),
    width: '12%',
  },
  {
    title: 'Тема',
    dataIndex: 'theme',
    key: 'theme',
    width: '25%',
    render: (_, object) => (
      <Row justify="center">
        <a onClick={() => window.open(routeGenerator.application2CoexecutorLink(object.id), '_blank')}>{object.coexecutorsPersonId?.theme}</a>
      </Row>
    ),
  },
  {
    title: 'Организация',
    dataIndex: 'poluchatel',
    key: 'poluchatel',
    width: '25%',
    render: (_, object) => (
      <Row justify="center">
        {object.poluchatel}
      </Row>
    ),
  },
];

export default getCoexecutorColumns;
